const READ_ONLY_CHANNELS = [
  'inbound',
  'social_media',
  'paid_marketing',
  'marketing_partner',
  'content_marketing'
];

export default READ_ONLY_CHANNELS;
